<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Turto rūšis</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <template v-if="noDavejas">
              <v-alert dense outlined type="error">
                Neįvesti nė vieno įkaito davėjo duomenys.
              </v-alert>
            </template>
            <v-row no-gutters>
              <v-col cols="12">
                <el-autocomplete
                  required
                  :readonly="noDavejas"
                  :items="items"
                  itemvalue="key"
                  itemtext="title"
                  return-object
                  label="Pasirinkite turto rūšį"
                  tooltip="Hipoteka. Turtas. Modalas turto rūšis"
                  v-model="turtasRusis"
                  autofocus
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          Atšaukti
        </el-button>
        <el-button v-if="!noDavejas" primary @click.native.stop="saveData()">
          Tęsti
        </el-button>
        <el-button v-if="noDavejas" primary @click.native.stop="gotoDavejas()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalTurtasRusis',
  props: {
    title: String,
    text: String,
    action: String,
    items: Array,
    value: Boolean,
    noDavejas: { type: Boolean, default: false },
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      turtasRusis: null,
    }
  },
  computed: {
    showTitle() {
      return this.title
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    modalAction() {
      return 'TurtasRusis'
    },
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit('confirm' + this.modalAction, this.turtasRusis)
          this.closeModal()
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    cancelData() {
      this.$emit('cancel' + this.modalAction)
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
    gotoDavejas() {
      this.$router.push({ name: 'hipotekaIkaitoDavejai' })
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
